import { WithSurveyNamespace } from '../../../state/survey';
import { getOptionalQuestionsByAttendee } from '../../../utils/surveys';
import { getQuestionsForAttendees } from '../untypedSurveySelectors';

export const hasOptionalQuestions = <State extends WithSurveyNamespace>(
    state: State,
) => {
    const optionalQuestionsByAttendee = getOptionalQuestionsByAttendee(
        getQuestionsForAttendees(state),
    );

    const attendeeIds = Object.keys(optionalQuestionsByAttendee);

    return attendeeIds.some(
        (attendeeId) =>
            Object.keys(optionalQuestionsByAttendee[attendeeId]).length > 0,
    );
};
